import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const NotFoundWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f5f5 0%, #fff 100%);
`;

const NotFoundContent = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;

  .container {
    max-width: 800px;
    width: 100%;
    text-align: center;
  }

  .error-code {
    font-size: 120px;
    font-weight: 900;
    background: linear-gradient(135deg, #000000 0%, #333333 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0;
    line-height: 1;
    font-family: "Outfit", sans-serif;
    data-aos: fade-up;
  }

  .error-title {
    font-size: 2.5rem;
    font-weight: 700;
    color: #000;
    margin: 20px 0;
    font-family: "Outfit", sans-serif;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  .error-description {
    font-size: 16px;
    color: #666;
    margin: 20px 0 40px;
    line-height: 1.6;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }

  .error-icon {
    font-size: 80px;
    margin-bottom: 20px;
    opacity: 0.8;
  }

  .action-buttons {
    display: flex;
    gap: 15px;
    justify-content: center;
    flex-wrap: wrap;

    button {
      min-width: 150px;
      height: 45px;
      font-size: 16px;
      font-weight: 600;
      border-radius: 4px;
      transition: all 0.3s ease;
      cursor: pointer;

      &:first-child {
        background: #000;
        color: white;
        border: none;

        &:hover {
          background: #333;
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
        }
      }

      &:last-child {
        background: transparent;
        color: #000;
        border: 2px solid #000;

        &:hover {
          background: #000;
          color: white;
          transform: translateY(-2px);
        }
      }
    }
  }

  .features {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    margin-top: 60px;
    padding-top: 60px;
    border-top: 1px solid #e8e8e8;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .feature {
      text-align: center;

      .feature-icon {
        font-size: 40px;
        margin-bottom: 15px;
      }

      .feature-title {
        font-size: 16px;
        font-weight: 600;
        color: #000;
        margin-bottom: 8px;
      }

      .feature-text {
        font-size: 14px;
        color: #666;
      }
    }
  }
`;

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <NotFoundWrapper>
      {/* <Navbar /> */}
      <NotFoundContent>
        <div className="container">
          <div className="error-icon">🔍</div>
          <p className="error-code" data-aos="fade-up">
            404
          </p>
          <h1 className="error-title" data-aos="fade-up" data-aos-delay="100">
            Page Not Found
          </h1>
          <p
            className="error-description"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            Oops! The page you're looking for doesn't exist. It might have been
            moved, deleted, or the URL might be incorrect. Don't worry, let's
            get you back on track!
          </p>

          <div
            className="action-buttons"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <button onClick={() => navigate("/")}>Back to Home</button>
            <button onClick={() => window.history.back()}>Go Back</button>
          </div>

          <div className="features">
            <div className="feature" data-aos="fade-up" data-aos-delay="400">
              <div className="feature-icon">🏠</div>
              <div className="feature-title">Home</div>
              <div className="feature-text">Return to our homepage</div>
            </div>
            <div className="feature" data-aos="fade-up" data-aos-delay="500">
              <div className="feature-icon">🛍️</div>
              <div className="feature-title">Shop</div>
              <div className="feature-text">Browse our products</div>
            </div>
            <div className="feature" data-aos="fade-up" data-aos-delay="600">
              <div className="feature-icon">📧</div>
              <div className="feature-title">Support</div>
              <div className="feature-text">Contact us for help</div>
            </div>
          </div>
        </div>
      </NotFoundContent>
      <Footer />
    </NotFoundWrapper>
  );
};

export default NotFound;
